import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { calcRouteWithParameters } from "abweb/service/router/RouteEmitter";
export class ReactRouteImpl {
  constructor(routeTemplate, routeProps, routeParams = {}, routeExtraParams = {}, preCalculatedRoute) {
    _defineProperty(this, "routeProps", void 0);
    _defineProperty(this, "routeParams", void 0);
    _defineProperty(this, "routeExtraParams", void 0);
    _defineProperty(this, "_route", void 0);
    this.routeTemplate = routeTemplate;
    this._route = preCalculatedRoute;
    // Removed freeze (top-level, plus props, params, extraParams) as too onerous for developers, see ABSDK-4999 for details
    this.routeProps = {
      ...routeProps
    };
    this.routeParams = routeParams ? {
      ...routeParams
    } : {};
    this.routeExtraParams = routeExtraParams ? {
      ...routeExtraParams
    } : {};
  }
  get route() {
    if (this._route === undefined) {
      // Injects required/optional params if they exist in route, and adds any extra params if they exist
      this._route = calcRouteWithParameters(this.routeTemplate, this.routeParams, this.routeExtraParams);
    }
    return this._route;
  }
  toString() {
    return `ReactRouteImpl{route: '${this.route}', routeTemplate: '${this.routeTemplate}', ` + `routeParams: ${JSON.stringify(this.routeParams)}, extraParams: ${JSON.stringify(this.routeExtraParams)}}`;
  }
}
//# sourceMappingURL=ReactRouteImpl.js.map
